// extracted by mini-css-extract-plugin
export var avatar = "_s5-3";
export var avatarContainer = "_s5-2";
export var avatarSpacer = "_s5-5";
export var avatarSpacerContainer = "_s5-4";
export var avatarStackContainer = "_s5-1";
export var bubble = "_s5-0";
export var remainderBubble = "_s5-6";